import getValidationError from '@assetsJsModule/dropzone/service/getValidationError';
import { maxNumberOfFiles, maxTotalFilesSize, allowedMimeTypes } from '../config/constants';

const validate = (values, props) => {
    const { t } = props;
    const errors = {};

    if (!values.name || !values.name.trim()) {
        errors.name = t('This value should not be blank.');
    }

    if (values.name && values.name.length < 2) {
        [errors.name] = t('This value is too short. It should have {{ limit }} character or more.|This value is too short. It should have {{ limit }} characters or more.')
            .replace('{{ limit }}', 2)
            .split('|');
    }

    if (values.name && values.name.length > 54) {
        [errors.name] = t('This value is too long. It should have {{ limit }} character or less.|This value is too long. It should have {{ limit }} characters or less.')
            .replace('{{ limit }}', 54)
            .split('|');
    }

    if (!values.email || !values.email.trim()) {
        errors.email = t('This value should not be blank.');
    }

    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = t('This value is not a valid email address.');
    }

    if (!values.subject || !values.subject.trim()) {
        errors.subject = t('This value should not be blank.');
    }

    if (values.subject && values.subject.length < 3) {
        [errors.subject] = t('This value is too short. It should have {{ limit }} character or more.|This value is too short. It should have {{ limit }} characters or more.')
            .replace('{{ limit }}', 3)
            .split('|');
    }

    if (values.subject && values.subject.length > 73) {
        [errors.subject] = t('This value is too long. It should have {{ limit }} character or less.|This value is too long. It should have {{ limit }} characters or less.')
            .replace('{{ limit }}', 73)
            .split('|');
    }

    if (!values.message || !values.message.trim()) {
        errors.message = t('This value should not be blank.');
    }

    if (values.message && values.message.length < 5) {
        [errors.message] = t('This value is too short. It should have {{ limit }} character or more.|This value is too short. It should have {{ limit }} characters or more.')
            .replace('{{ limit }}', 5)
            .split('|');
    }

    if (values.message && values.message.length > 5000) {
        [errors.message] = t('This value is too long. It should have {{ limit }} character or less.|This value is too long. It should have {{ limit }} characters or less.')
            .replace('{{ limit }}', 5000)
            .split('|');
    }

    const attachmentValidationError = getValidationError(
        values.attachments || [],
        maxNumberOfFiles,
        maxTotalFilesSize,
        allowedMimeTypes,
    );

    if (attachmentValidationError !== null) {
        errors.attachments = attachmentValidationError;
    }

    return errors;
};

export default validate;
